<template>
    <v-card elevation="1">
        <v-card-title>
            Shutter Check-Inventory Management
        </v-card-title>

        <div v-if="!printVisible">
            <v-data-table :headers="headers" :items="radiationInspectionList"
            :items-per-page="10"
            item-key="radiationId"
            class="elevation-1"
            :search="search"
            @current-items="getFilteredItems">
            <template v-slot:top>
                <v-row>
                    <v-col cols="8">
                        <v-text-field v-model="search" label="Search" class="mx-4"></v-text-field>    
                    </v-col>
                    <v-col cols="2">
                        <vue-excel-xlsx
                         :data="radiationInspectionList"
                         :columns="headersExport"
                         :file-name="fileName"
                         :file-type="'xlsx'"
                         :sheet-name="'RadiationShutterCheck'">
                            <v-btn color="blue-grey" class="ma-2 white--text">
                                Export
                                <v-icon right dark>mdi-cloud-download</v-icon>
                            </v-btn>
                         </vue-excel-xlsx>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="success" class="ma-2 white--text" @click="printPreview">Preview
                            <v-icon aria-hidden="false">mdi-printer-eye</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                
            </template>
                                  
            <template #item.radiationId="{value}">
              <a v-on:click.stop.prevent="avoidRefresh(`/radiation/updateradiation/${value}`)"  ><v-icon aria-hidden="false">fas fa-edit</v-icon></a>
            </template>
            </v-data-table>
        </div>

        <div v-if="printVisible">
            <PrintReport 
                :items="radiationInspectionList" 
                :headers="headers"
                :title="'Radiation Shutter Check List'"
                @clicked="onClickChild">
            </PrintReport>
        </div>
    </v-card>

     
</template>


<script>

import reportsAPI from '@/services/reportsservice';
import moment from 'moment';
import PrintReport from './PrintReport.vue';
export default ({
    name: 'RadiationInspectionList',
    data:function(){
        return {
            search:'',
            fileName:'RadiationShuttercheckList'+moment(Date.now()).format('YYYY-MM-DD'),
            printVisible:false,
            radiationInspectionList:[],
            filteredItems:[]
        }
        
    },
    computed:{
          headers(){
            return [
                { text:'', align:'start', sortable:false, value:'radiationId'},
                { text:'Serial Number', align:'start', sortable:false, value:'serialNumber'},
                { text:'Building', align:'start', sortable:true, value:'building.value'},
                { text:'Floor', align:'start', sortable:true, value:'floor.value'},
                { text:'Location', align:'start', sortable:true, value:'location'},
                { text:'Last Check Date',align: 'start', sortable:true, value:'lastCheckDate'},
                { text: 'Next Check Date', align:'start', sortable:true, value: 'nextCheckDate'},
                { text: 'Area Management Contact', align:'start', sortable:true, value: 'managementContact'},
                { text: 'Primary Contact', align:'start', sortable:true, value: 'primaryContact'}
                ]
          },
          headersExport(){
                 return [
                    //{ label:'Id',  field:'radiationId'},
                    { label: 'Serial Number', field:'serialNumber'},
                    { label:'Building',  field:'building.value'},
                    { label:'Floor',  field:'floor.value'},
                    { label:'Location',  field:'location'},
                    { label:'Last Check Date',  field:'lastCheckDate'},
                    { label:'Next Check Date',  field:'nextCheckDate'},
                    { label:'Area Management Contact', field:'managementContact'},
                    { label:'Primary Contact', field:'primaryContact'}
                    
                 ]
            },
            userAccount()
            {
                return this.$userAccount;
            }
    },
    mounted: function()
    {
        console.log('this.userAccount',this.userAccount);
        reportsAPI.GetRadiationShutterCheckList()
        .then(response=>{
            this.radiationInspectionList=response.data;
        })
        .catch(error=>{
            console.log(error);
        });
      
    },
    methods:{
      async getFilteredItems(e){
          this.filteredItems=e;
          console.log(this.filteredItems);
      },
      async printPreview()
      {
          this.printVisible=true;
      },
      async onClickChild(){
          this.printVisible=false;
      },
      async avoidRefresh(value){
        this.$router.push(value);
      }
    },
    components:{
        PrintReport
    }
    
})
</script>
